import React, { Component } from 'react';
import { observer, inject} from 'mobx-react';
import { LargeButton, ButtonType } from '@checkmarx/cx-ui';
import classNames from 'classnames';
import styles from './style.scss';

@inject('translationsStore', 'resetPasswordStore', 'configurationsStore') @observer
export default class ResetPasswordPerformed extends Component {

    state = {
        goToLoginPageClicked: false,
        goToSCAPageClicked: false
    };

    handleLoginClick = (e) => {

        this.setState({goToLoginPageClicked: true});

        window.location.href = './';
    }

    handleSCAClick = (e) =>{
        this.setState({goToSCAPageClicked: true});
        const { scaUrl } = this.props.configurationsStore;
        window.location.href = scaUrl;
    }

    render() {     
        
        const { isMultitenancyMode } = this.props.configurationsStore;

        let SCAButtons = <LargeButton
                            id='btnResetPasswordCompleteSubmitRedirectToSCA'
                            dataCy='reset-password-complete-button'
                            onClick={this.handleSCAClick}
                            inProgress={this.state.goToSCAPageClicked}
                            text='SCA'
                            style={{marginTop: '15px'}}
                        />

        return(
            <div className='reset-password'>
                <div className='general-form-wrapper reset-success'>             
                    <div className={classNames(styles.titleWrapper)}>
                        <span>
                            {this.props.translationsStore.translate('PASSWORD_HAS_BEEN_UPDATED')}
                        </span>
                    </div>
                    {isMultitenancyMode ? SCAButtons : null}
                    <LargeButton
                        id='btnResetPasswordCompleteSubmit'
                        dataCy='reset-password-complete-button'
                        onClick={this.handleLoginClick}
                        inProgress={this.state.goToLoginPageClicked}
                        text="Access Control"
                        style={{marginTop: '15px'}}
                    />
                </div>
            </div>
        );
    }
}